import SameProduct from './SameProduct.jsx';

export {
  SameProduct
}


// WEBPACK FOOTER //
// ./components/partials/product/popup-view-detail/same-product/index.js